/** Fixture data from Glimpse_Wip_Report_Design / spec §3.7 */

export const wipAiFixture = {
  project: {
    _id: 'p_123',
    salesforce_id: '0015g000001',
    name: 'DOJ Opiod ABC',
    client: 'Department of Justice',
    Address: '615 Chestnut Street, Ste. 1250',
    CurrencyIsoCode: 'USD',
    matterNumber: 'DOJ-2026-OPD-0042',
  },
  person: { _id: 'u_1', fullName: 'Alex Paez', email: 'alex@ks.com' },
  today: '2026-04-22',
  currentMonth: '2026-04',
  wipReport: {
    projectId: 'p_123',
    monthlyWipReports: [
      {
        month: '2026-01',
        budget: 75000,
        wipPacing: '98%',
        totalFeesAndExpenses: 73500,
        submittedHours: { staffHours: 310, staffRate: 72000, expertHours: 0, expertRate: 0 },
        submittedExpenses: { staffExpenses: 1500, expertExpenses: 0, writeOffs: 0 },
        submittedWriteOffs: 0,
        hoursDetails: [],
        expensesDetails: [],
        invoiceDiscount: { isPercentage: false, value: 0 },
      },
      {
        month: '2026-02',
        budget: 87500,
        wipPacing: '105%',
        totalFeesAndExpenses: 91800,
        submittedHours: { staffHours: 365, staffRate: 90000, expertHours: 0, expertRate: 0 },
        submittedExpenses: { staffExpenses: 1800, expertExpenses: 0, writeOffs: 0 },
        submittedWriteOffs: 0,
        hoursDetails: [],
        expensesDetails: [],
        invoiceDiscount: { isPercentage: false, value: 0 },
      },
      {
        month: '2026-03',
        budget: 80000,
        wipPacing: '112%',
        totalFeesAndExpenses: 89400,
        submittedHours: { staffHours: 348, staffRate: 87500, expertHours: 0, expertRate: 0 },
        submittedExpenses: { staffExpenses: 1900, expertExpenses: 0, writeOffs: 0 },
        submittedWriteOffs: 0,
        hoursDetails: [],
        expensesDetails: [],
        invoiceDiscount: { isPercentage: false, value: 0 },
      },
      {
        month: '2026-04',
        budget: 80000,
        wipPacing: '112%',
        totalFeesAndExpenses: 89521.02,
        submittedHours: { staffHours: 289, staffRate: 85400, expertHours: 0, expertRate: 0 },
        submittedExpenses: { staffExpenses: 4121.02, expertExpenses: 0, writeOffs: 0 },
        submittedWriteOffs: 0,
        hoursDetails: [
          {
            personName: 'Alex Paez',
            date: '2026-04-02',
            comment: 'Doc review',
            hours: 8,
            total: 2200,
          },
          {
            personName: 'Alex Paez',
            date: '2026-04-09',
            comment: 'Drafting memo',
            hours: 12,
            total: 3300,
          },
          {
            personName: 'Alex Paez',
            date: '2026-04-16',
            comment: 'Drafting memo',
            hours: 10,
            total: 2750,
          },
          {
            personName: 'Priya Shah',
            date: '2026-04-03',
            comment: 'Deposition prep',
            hours: 9,
            total: 2700,
          },
          {
            personName: 'Priya Shah',
            date: '2026-04-10',
            comment: 'Deposition prep',
            hours: 11,
            total: 3300,
          },
          {
            personName: 'Priya Shah',
            date: '2026-04-17',
            comment: 'Client call + prep',
            hours: 15,
            total: 4500,
          },
          {
            personName: 'Jordan Ellis',
            date: '2026-04-05',
            comment: 'Research',
            hours: 19,
            total: 4750,
          },
          {
            personName: 'Jordan Ellis',
            date: '2026-04-12',
            comment: 'Research — experts',
            hours: 14,
            total: 3500,
          },
          {
            personName: 'Jordan Ellis',
            date: '2026-04-19',
            comment: 'Exhibit index',
            hours: 12,
            total: 3000,
          },
          {
            personName: 'Mara Koenig',
            date: '2026-04-04',
            comment: 'Filings coordination',
            hours: 6,
            total: 1680,
          },
          {
            personName: 'Mara Koenig',
            date: '2026-04-11',
            comment: 'Filings coordination',
            hours: 7,
            total: 1960,
          },
          {
            personName: 'Mara Koenig',
            date: '2026-04-18',
            comment: 'Status tracker',
            hours: 5,
            total: 1400,
          },
        ],
        expensesDetails: [
          {
            personName: 'Alex Paez',
            date: '2026-04-05',
            description: 'Westlaw research credits',
            account: 'Research Services',
            cost: 1250,
          },
          {
            personName: 'Priya Shah',
            date: '2026-04-12',
            description: 'Deposition travel — ORD→PHL',
            account: 'Travel',
            cost: 1420.5,
          },
          {
            personName: 'Alex Paez',
            date: '2026-04-18',
            description: 'Printing / binders',
            account: 'Reproduction',
            cost: 340,
          },
          {
            personName: 'Jordan Ellis',
            date: '2026-04-08',
            description: 'Document hosting',
            account: 'Technology',
            cost: 610.52,
          },
          {
            personName: 'Mara Koenig',
            date: '2026-04-14',
            description: 'Filing fees (ECF)',
            account: 'Court Fees',
            cost: 500,
          },
        ],
        invoiceDiscount: { isPercentage: false, value: 0 },
      },
      {
        month: '2026-05',
        budget: 85000,
        wipPacing: '0%',
        totalFeesAndExpenses: 0,
        submittedHours: { staffHours: 0, staffRate: 0, expertHours: 0, expertRate: 0 },
        submittedExpenses: { staffExpenses: 0, expertExpenses: 0, writeOffs: 0 },
        submittedWriteOffs: 0,
        hoursDetails: [],
        expensesDetails: [],
        invoiceDiscount: { isPercentage: false, value: 0 },
      },
      {
        month: '2026-06',
        budget: 90000,
        wipPacing: '0%',
        totalFeesAndExpenses: 0,
        submittedHours: { staffHours: 0, staffRate: 0, expertHours: 0, expertRate: 0 },
        submittedExpenses: { staffExpenses: 0, expertExpenses: 0, writeOffs: 0 },
        submittedWriteOffs: 0,
        hoursDetails: [],
        expensesDetails: [],
        invoiceDiscount: { isPercentage: false, value: 0 },
      },
    ],
  },
  keyDates: [
    {
      Name: 'Expert Report Due',
      Description__c: 'Initial expert report',
      StartDate__c: '2026-04-28',
      EndDate__c: '2026-04-28',
      DateRange__c: '2026-04-28',
      Project__c: 'p_123',
    },
    {
      Name: 'Meet & Confer',
      Description__c: 'With opposing counsel',
      StartDate__c: '2026-05-05',
      EndDate__c: '2026-05-05',
      DateRange__c: '2026-05-05',
      Project__c: 'p_123',
    },
    {
      Name: 'Status Conference',
      Description__c: 'With the court',
      StartDate__c: '2026-05-12',
      EndDate__c: '2026-05-12',
      DateRange__c: '2026-05-12',
      Project__c: 'p_123',
    },
    {
      Name: 'Deposition — Adams',
      Description__c: 'Corporate rep 30(b)(6)',
      StartDate__c: '2026-06-03',
      EndDate__c: '2026-06-03',
      DateRange__c: '2026-06-03',
      Project__c: 'p_123',
    },
  ],
  invoiceTotals: [
    { month: 'January 2026', total: 72000 },
    { month: 'February 2026', total: 88000 },
    { month: 'March 2026', total: 85000 },
  ],
  assignments: [
    { personId: 'u_paez', personName: 'Alex Paez', weeklyHours: 20 },
    { personId: 'u_shah', personName: 'Priya Shah', weeklyHours: 10 },
    { personId: 'u_ellis', personName: 'Jordan Ellis', weeklyHours: 8 },
    { personId: 'u_koenig', personName: 'Mara Koenig', weeklyHours: 6 },
  ],
  weeklyPacing: [
    { week: 'Apr 01–05', target: 20000, actual: 19480 },
    { week: 'Apr 06–12', target: 20000, actual: 22480 },
    { week: 'Apr 13–19', target: 20000, actual: 25360 },
    { week: 'Apr 20–26', target: 20000, actual: 22201 },
  ],
  expenseSparks: {
    'Research Services': [420, 310, 510, 280, 390, 620, 480, 330, 410, 560, 780, 1250],
    Travel: [0, 1100, 0, 0, 720, 0, 0, 1050, 0, 0, 0, 1420],
    Reproduction: [140, 220, 180, 310, 260, 290, 240, 320, 350, 290, 310, 340],
    Technology: [600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 600, 610],
    'Court Fees': [0, 0, 420, 0, 0, 0, 0, 0, 0, 0, 0, 500],
  },
}

export function formatCurrency(value, iso = 'USD') {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: iso,
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatCurrencyCents(value, iso = 'USD') {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: iso,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatPct(value) {
  if (value == null) return '—'
  return `${Math.round(value)}%`
}

export function monthLabel(ym) {
  const [y, m] = ym.split('-').map(Number)
  return new Date(y, m - 1, 1).toLocaleString('en-US', { month: 'long', year: 'numeric' })
}

export function shortMonth(ym) {
  const [y, m] = ym.split('-').map(Number)
  return new Date(y, m - 1, 1).toLocaleString('en-US', { month: 'short', year: 'numeric' })
}
